import { apiClient } from './client'

// Auth API functions that match your backend after UUID refactor
export const authAPI = {
  // Login now expects email (but field name is still 'username' for backend compatibility)
  login: (email: string, password: string) =>
    apiClient.post('/login', new URLSearchParams({ username: email, password }), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    }),

  // Signup no longer requires username
  signup: (email: string, password: string, name?: string) =>
    apiClient.post('/signup', { email, password, ...(name && { name }) }),

  logout: () => apiClient.post('/logout'),

  sendVerificationEmail: (email: string) => apiClient.post('/send-verification-email', { email }),

  verifyEmail: (token: string) => apiClient.post('/verify-email', { token }),

  sendPasswordReset: (email: string) => apiClient.post('/send-password-reset', { email }),

  resetPassword: (token: string, new_password: string) =>
    apiClient.post('/reset-password', { token, new_password }),

  getProfile: () => apiClient.get('/users/me'),
}

// Auth utilities
export const authUtils = {
  setToken: (token: string) => {
    localStorage.setItem('auth_token', token)
  },

  getToken: (): string | null => {
    return localStorage.getItem('auth_token')
  },

  removeToken: () => {
    localStorage.removeItem('auth_token')
  },

  setRefreshToken: (token: string) => {
    localStorage.setItem('refresh_token', token)
  },

  getRefreshToken: (): string | null => {
    return localStorage.getItem('refresh_token')
  },

  removeRefreshToken: () => {
    localStorage.removeItem('refresh_token')
  },

  isAuthenticated: (): boolean => {
    return !!localStorage.getItem('auth_token')
  },
}
